// extracted by mini-css-extract-plugin
export default {"list":"ancestor_list__1jZEU"};